/**
 * Add the ff. class are setup in the section to make the video worked
 *
 * 1. Video tag should have .js-video-tag
 *
 * 2. Add data-target-cont to set the parent class. (Ideally, this should
 * be added in the element that is used to trigger the click event to play the video
 * )
 *
 * 3. Add .js-hide-on-play to the elements you want to hide when the
 * video is played
 *
 * 4. The element you want to set as trigger to play/pause the video should have
 * .js-playvideo. This is mostly added in the play button.
 *
 *
 */
import { stokpressViewPort } from "../util/helper";
var config = {
  selector: {
    hideOnPlay: ".js-hide-on-play",
    removeOnPlay: ".js-remove-on-play"
  },
  classes: {
    hide: "d-none",
    playButton: "js-playvideo"
  }
};
var isAutoplaySupported = function isAutoplaySupported(callback) {
  if (!sessionStorage.autoPlaySupported) {
    var video = document.createElement("video");
    video.autoplay = true;
    video.muted = true;
    video.setAttribute("webkit-playsinline", "webkit-playsinline");
    video.setAttribute("playsinline", "playsinline");
    video.src = "data:video/mp4;base64,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";
    video.load();
    video.style.display = "none";
    video.playing = false;
    video.play().catch(function (err) {
      return console.log(err);
    });
    video.onplay = function () {
      this.playing = true;
    };

    // Video has loaded, check autoplay support
    video.oncanplay = function () {
      if (video.playing) {
        sessionStorage.autoPlaySupported = "true";
        callback(true);
      } else {
        sessionStorage.autoPlaySupported = "false";
        callback(false);
      }
    };
  } else {
    if (sessionStorage.autoPlaySupported == "true") {
      callback(true);
    } else {
      callback(false);
    }
  }
};
var removeElementsOnPlay = function removeElementsOnPlay(wrapperEl) {
  if (!wrapperEl) {
    return;
  }
  removeElement(wrapperEl);
  hideElement(wrapperEl, "hide");
};
var removeElement = function removeElement(wrapperEl) {
  if (!wrapperEl) {
    return;
  }
  var elToHide = wrapperEl.querySelectorAll(config.selector.removeOnPlay);
  if (elToHide.length === 0) {
    return;
  }
  Array.prototype.forEach.call(elToHide, function (element) {
    element.parentNode.removeChild(element);
  });
};
var hideElement = function hideElement(wrapperEl, action) {
  if (!wrapperEl) {
    return;
  }
  var items = wrapperEl.querySelectorAll(config.selector.hideOnPlay);
  if (items.length === 0) {
    return;
  }
  Array.prototype.forEach.call(items, function (item) {
    if (action === "hide") {
      item.classList.add(config.classes.hide);
    } else {
      item.classList.remove(config.classes.hide);
    }
  });
};

// Get video setting base on device type
var getVideoData = function getVideoData(video) {
  if (video.dataset.desktop == undefined) {
    return {
      src: video.getAttribute("data-src") || video.getAttribute("src"),
      autoplay: video.getAttribute("autoplay") === "autoplay" ? true : false
    };
  }

  // Set Desktop data as default
  var deviceData = video.dataset.desktop;

  // Get mobile data if has value and viewport is less tha 767
  if (video.dataset.mobile && stokpressViewPort.documentWidth().width < 767) {
    deviceData = video.dataset.mobile;
  }
  return JSON.parse(deviceData);
};
var getElParent = function getElParent(el) {
  if (!el) {
    return;
  }
  var wrapperClass = el.data("target-cont");
  var parent = el.parent().parent();
  if (typeof wrapperClass !== "undefined") {
    var tempParent = el.parents(".".concat(wrapperClass));

    // Only override parent if selector exist
    if (tempParent.length) {
      parent = tempParent;
    }
  }
  return parent.length ? parent[0] : null;
};
var videoOnClick = function videoOnClick(playVideo) {
  if (playVideo.length === 0) return;
  playVideo.off("click").on("click", function (e) {
    e.preventDefault();
    var targetParent = getElParent($(e.currentTarget));
    var targetVideo = targetParent.querySelector("video");
    if (targetVideo.paused == false) {
      targetVideo.pause();
      removeElementsOnPlay(targetParent);
    } else {
      targetVideo.setAttribute("data-played", true);
      updateVideo(targetParent, targetVideo);
      targetVideo.play().catch(function (err) {
        return console.log(err);
      });
      removeElementsOnPlay(targetParent);
    }
    targetVideo.style.zIndex = 1;
  });
};
var videoLazyLoad = function videoLazyLoad(videoParent) {
  var options = {
    root: null,
    rootMargin: "0px",
    threshold: 0
  };
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var video = entry.target.querySelector("video");
        var data = getVideoData(video);
        if (video.dataset.played === "true") {
          return;
        }

        /**
         * End process if video not autoplay and not yet played 
         * this is to avoid loading the video if not yet needed 
         **/
        if (data.autoplay === false && video.dataset.played !== "true") {
          return;
        }
        if (data.autoplay === true) {
          processAutoplay(video, videoParent);
        } else {
          video.autoplay = false;
          video.muted = false;
        }
        video.setAttribute("src", video.dataset.src);
        video.load();
        observer.unobserve(video);
      }
    });
  }, options);
  observer.observe(videoParent);
};
var processAutoplay = function processAutoplay(video, videoParent) {
  if (!video) return;
  isAutoplaySupported(function (canAutoplay) {
    if (canAutoplay === false) {
      return;
    }
    video.setAttribute("data-played", true);
    video.style.zIndex = 1;
    video.autoplay = true;
    video.muted = true;
    removeElementsOnPlay(videoParent);
  });
};
var updateVideo = function updateVideo(parent, video) {
  if (!parent) return;
  var data = getVideoData(video);
  var isLazyLoad = video.dataset.lazyload === "true";
  if (data.src != video.src) {
    if (video.dataset.played === "true") {
      video.setAttribute("src", data.src);
      video.load();
      video.play().catch(function (err) {
        return console.log(err);
      });
    } else if (isLazyLoad) {
      video.setAttribute("data-src", data.src);
    }
  }
};
var flexibleVideo = function flexibleVideo() {
  var onLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var jsVideo = $("video.js-video-tag");
  if (jsVideo.length === 0) return;
  jsVideo.each(function () {
    var _this = $(this);
    var videoParent = getElParent(_this);
    var currentVideo = videoParent.querySelector("video");
    var isLazyLoad = currentVideo.dataset.lazyload === "true";

    // Update video src based on window
    if (currentVideo) {
      updateVideo(videoParent, currentVideo);
    }

    // Do this onload only
    if (onLoad === true) {
      videoOnClick($(videoParent).find("." + config.classes.playButton));
      if (isLazyLoad) {
        videoLazyLoad(videoParent);
      } else if (currentVideo.autoplay === true) {
        processAutoplay(currentVideo, videoParent);
      }
    }
  });
};
$(window).on("resize", function () {
  flexibleVideo(false);
});
export default flexibleVideo;


// WEBPACK FOOTER //
// ./scripts/components/flexible-video.js